// // components/PartnerSignup/PartnerSignup.jsx
// import React, { useState } from "react";
// import { useNavigate } from 'react-router-dom';
// import { collection, addDoc, Timestamp } from "firebase/firestore";
// import { db } from "../../firebase"; // Adjust path as needed
// import "./PartnerForm.css";

// const PartnerSignup = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
    
//     // Clear error when user starts typing
//     if (errors[name]) {
//       setErrors({ ...errors, [name]: "" });
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
    
//     if (!formData.firstName.trim()) {
//       newErrors.firstName = "First name is required";
//     }
    
//     if (!formData.lastName.trim()) {
//       newErrors.lastName = "Last name is required";
//     }
    
//     if (!formData.email.trim()) {
//       newErrors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = "Email is invalid";
//     }
    
//     if (!formData.phone.trim()) {
//       newErrors.phone = "Phone number is required";
//     } else if (!/^\d{10}$/.test(formData.phone.replace(/\D/g, ""))) {
//       newErrors.phone = "Phone number must be 10 digits";
//     }
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) return;
    
//     setIsSubmitting(true);
    
//     try {
//       // Add document to Firebase Firestore
//       const partnerData = {
//         firstName: formData.firstName.trim(),
//         lastName: formData.lastName.trim(),
//         email: formData.email.trim().toLowerCase(),
//         phone: formData.phone.trim(),
//         status: "pending",
//         createdAt: Timestamp.now(),
//         fullName: `${formData.firstName.trim()} ${formData.lastName.trim()}`,
//       };

//       // Save to 'partnerinfo' collection
//       const docRef = await addDoc(collection(db, "partnerinfo"), partnerData);
      
//       console.log("Document written with ID: ", docRef.id);
      
//       // Success feedback
//       alert(`Welcome ${formData.firstName} ${formData.lastName}! Your partner application has been submitted successfully.`);
      
//       // Navigate back to home page
//       navigate('/');
      
//     } catch (error) {
//       console.error("Error adding document: ", error);
//       setErrors({ submit: "Failed to submit application. Please try again." });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="partner-signup-page">
//       <div className="partner-signup-container">
//         <div className="partner-signup-card">
//           {/* Back Button */}
//           <button className="back-btn" onClick={() => navigate('/')}>
//             ← Back to Home
//           </button>

//           <h1>
//             Become a <span className="brand-highlight">Partner</span>
//           </h1>
//           <p className="partner-signup-subtitle">
//             Join our network and grow your business with us
//           </p>

//           {errors.submit && (
//             <div className="error-message">
//               {errors.submit}
//             </div>
//           )}

//           <form onSubmit={handleSubmit} noValidate>
//             <div className="form-row">
//               <div className="form-group">
//                 <label htmlFor="firstName">First Name *</label>
//                 <input
//                   type="text"
//                   id="firstName"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleChange}
//                   placeholder="Enter your first name"
//                   className={errors.firstName ? "error" : ""}
//                   disabled={isSubmitting}
//                 />
//                 {errors.firstName && <span className="field-error">{errors.firstName}</span>}
//               </div>

//               <div className="form-group">
//                 <label htmlFor="lastName">Last Name *</label>
//                 <input
//                   type="text"
//                   id="lastName"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleChange}
//                   placeholder="Enter your last name"
//                   className={errors.lastName ? "error" : ""}
//                   disabled={isSubmitting}
//                 />
//                 {errors.lastName && <span className="field-error">{errors.lastName}</span>}
//               </div>
//             </div>

//             <div className="form-group">
//               <label htmlFor="email">Email Address *</label>
//               <input
//                 type="email"
//                 id="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 placeholder="Enter your email address"
//                 className={errors.email ? "error" : ""}
//                 disabled={isSubmitting}
//               />
//               {errors.email && <span className="field-error">{errors.email}</span>}
//             </div>

//             <div className="form-group">
//               <label htmlFor="phone">Phone Number *</label>
//               <input
//                 type="tel"
//                 id="phone"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 placeholder="Enter your 10-digit phone number"
//                 className={errors.phone ? "error" : ""}
//                 disabled={isSubmitting}
//               />
//               {errors.phone && <span className="field-error">{errors.phone}</span>}
//             </div>

//             <button 
//               type="submit" 
//               className={`submit-btn ${isSubmitting ? "loading" : ""}`}
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? "Submitting Application..." : "Join as a Partner"}
//             </button>
//           </form>

//           <div className="partner-benefits">
//             <h3>Partner Benefits</h3>
//             <ul>
//               <li>✓ Exclusive business opportunities</li>
//               <li>✓ Marketing and promotional support</li>
//               <li>✓ Dedicated partner manager</li>
//               <li>✓ Competitive commission structure</li>
//               <li>✓ Training and certification programs</li>
//             </ul>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PartnerSignup;
// components/PartnerSignup/PartnerSignup.jsx

import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../../firebase"; // Adjust path to your firebase.js file
import "./PartnerForm.css";

const PartnerSignup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }
    
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }
    
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone.replace(/\D/g, ""))) {
      newErrors.phone = "Phone number must be 10 digits";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setIsSubmitting(true);
    
    try {
      // Prepare data to save to Firestore
      const partnerData = {
        firstName: formData.firstName.trim(),
        lastName: formData.lastName.trim(),
        email: formData.email.trim().toLowerCase(),
        phone: formData.phone.trim(),
        fullName: `${formData.firstName.trim()} ${formData.lastName.trim()}`,
        status: "pending", // You can add status tracking
        createdAt: Timestamp.now(), // Firebase timestamp
        submittedFrom: "website", // Track source
      };

      // Save to Firebase Firestore 'partnerinfo' collection
      const docRef = await addDoc(collection(db, "partnerinfo"), partnerData);
      
      console.log("✅ Document successfully written with ID: ", docRef.id);
      
      // Success message
      alert(`🎉 Welcome ${formData.firstName} ${formData.lastName}! Your partner application has been submitted successfully. We'll contact you soon at ${formData.email}.`);
      
      // Reset form
      setFormData({ firstName: "", lastName: "", email: "", phone: "" });
      setErrors({});
      
      // Navigate back to home page after success
      navigate('/');
      
    } catch (error) {
      console.error("❌ Error adding document to Firestore: ", error);
      setErrors({ 
        submit: "Failed to submit your application. Please check your internet connection and try again." 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="partner-signup-page">
      <div className="partner-signup-container">
        <div className="partner-signup-card">
          {/* Back Button */}
          <button className="back-btn" onClick={() => navigate('/')}>
            ← Back to Home
          </button>

          <h1>
            Become a <span className="brand-highlight">Partner</span>
          </h1>
          <p className="partner-signup-subtitle">
          Manage your Events & Short-Term Tasks with us.
          </p>

          {/* Show submission error if any */}
          {errors.submit && (
            <div className="error-message">
              {errors.submit}
            </div>
          )}

          <form className="main-masti" onSubmit={handleSubmit} noValidate>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">First Name *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Enter your first name"
                  className={errors.firstName ? "error" : ""}
                  disabled={isSubmitting}
                  maxLength={50}
                />
                {errors.firstName && <span className="field-error">{errors.firstName}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Last Name *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter your last name"
                  className={errors.lastName ? "error" : ""}
                  disabled={isSubmitting}
                  maxLength={50}
                />
                {errors.lastName && <span className="field-error">{errors.lastName}</span>}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email address"
                className={errors.email ? "error" : ""}
                disabled={isSubmitting}
                maxLength={100}
              />
              {errors.email && <span className="field-error">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number * <i className="meme">suggested whatsapp number</i>    </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your 10-digit phone number "
                className={errors.phone ? "error" : ""}
                disabled={isSubmitting}
                maxLength={15}
              />
              {errors.phone && <span className="field-error">{errors.phone}</span>}
            </div>

            <button 
              type="submit" 
              className={`submit-btn ${isSubmitting ? "loading" : ""}`}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting Application..." : "Submit"}
            </button>
          </form>

          <div className="partner-benefits">
            <h3>Partner Benefits</h3>
            <ul>
              <li>✓ 100% Verified Gig Workers</li>
              <li>✓ No Hiring Commitments</li>
              <li>✓ No Recruitment Hassles</li>
              <li>✓ Hourly based Billing</li>
              <li>✓ The Real Cost Savings</li>
              <li>✓ Your Place, Our Service</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerSignup;
